export default __webpack_public_path__ + "static/media/926.3338bc4f.png";